var _path, _path2, _path3, _path4, _line, _line2, _line3, _line4, _mask, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnSiteVisit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 37,
    viewBox: "0 0 29 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.95318 34.3443L8.95337 34.3444C10.5571 34.9615 12.2688 35.2764 13.9952 35.2729C15.7199 35.2755 17.43 34.9606 19.0324 34.3445L19.0328 34.3443C20.5571 33.7575 21.9535 32.8978 23.1468 31.8093C24.3297 30.7381 25.2829 29.4519 25.9497 28.023L25.9506 28.0211C26.6302 26.5564 26.9822 24.9697 26.9822 23.3638C26.9822 21.7579 26.6302 20.1712 25.9506 18.7065L25.9497 18.7046C25.2829 17.2757 24.3297 15.9896 23.1468 14.9184C21.9535 13.8299 20.5571 12.9702 19.0328 12.3833V12.3833L19.0306 12.3825C15.7945 11.1456 12.1877 11.1456 8.95165 12.3825L8.95165 12.3825L8.94938 12.3833C7.42507 12.9702 6.02868 13.8298 4.83541 14.9184C3.65248 15.9895 2.69927 17.2757 2.03253 18.7046L2.03253 18.7046L2.03164 18.7065C1.35198 20.1712 1 21.7579 1 23.3638C1 24.9697 1.35198 26.5564 2.03164 28.0211L2.03164 28.0211L2.03279 28.0236C2.7007 29.4527 3.65524 30.7388 4.83953 31.8096C6.03272 32.898 7.42901 33.7575 8.95318 34.3443Z",
    fill: "#4E4E4E",
    stroke: "#A3A3A3",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6483 18.5L18.4998 9.20391C18.4998 9.20391 15.408 1.05481 22.6483 1.00027C29.8886 0.945724 27 9.20391 27 9.20391L22.6483 18.5Z",
    fill: "#A3A3A3",
    stroke: "#A3A3A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6682 8.7858C24.4105 8.7858 25.8228 7.47847 25.8228 5.8658C25.8228 4.25313 24.4105 2.9458 22.6682 2.9458C20.926 2.9458 19.5137 4.25313 19.5137 5.8658C19.5137 7.47847 20.926 8.7858 22.6682 8.7858Z",
    fill: "#4E4E4E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6677 8.60405C24.3049 8.60405 25.6322 7.37812 25.6322 5.86587C25.6322 4.35361 24.3049 3.12769 22.6677 3.12769C21.0304 3.12769 19.7031 4.35361 19.7031 5.86587C19.7031 7.37812 21.0304 8.60405 22.6677 8.60405Z",
    stroke: "#A3A3A3"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 13.3779,
    y1: 16.41,
    x2: 6.41047,
    y2: 22.3821,
    stroke: "#A3A3A3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 20.7235,
    y1: 22.4319,
    x2: 13.6036,
    y2: 16.4093,
    stroke: "#A3A3A3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 8.42383,
    y1: 20.8491,
    x2: 8.42383,
    y2: 29.7596,
    stroke: "#A3A3A3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 18.123,
    y1: 20.8491,
    x2: 18.123,
    y2: 29.7596,
    stroke: "#A3A3A3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-1_3053_3904",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 25,
    width: 3,
    height: 5,
    rx: 0.5
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 25,
    width: 3,
    height: 5,
    rx: 0.5,
    stroke: "#A3A3A3",
    strokeWidth: 3,
    mask: "url(#path-9-inside-1_3053_3904)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnSiteVisit);
export default __webpack_public_path__ + "static/media/on-site-visit.95f116b58872ed81b15ca333b2cfc535.svg";
export { ForwardRef as ReactComponent };